import AgencyManageAccoutTeam from './components/AgencyManageAccoutTeam.js';
import connect from './connect';
import './assets/AgencyManageAccoutTeam.css';

export default connect(AgencyManageAccoutTeam);



// WEBPACK FOOTER //
// ./src/routes/AgencyManageAccoutTeam/index.js